export const EmptyButton = ({
  // highlightColourOn,
  // highlightColourOff,
  backgroundColourOff,
  backgroundColourOn,
  // textColorOn,
  // textColorOff,
  text,
  isOn
  // onClick
}) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 54.95 54.95">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <rect
              x="2.11"
              y="3.51"
              width="50.08"
              height="47.9"
              fill={isOn ? backgroundColourOff : backgroundColourOn}
            />
            <path
              d="M53,52.79V53h-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M52.4,53h-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2.16,53H2v-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2,52.4v-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2,2.16V2h.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2.54,2H52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M52.79,2H53v.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M53,2.54V52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <text
              fill={isOn ? backgroundColourOn : backgroundColourOff}
              transform="translate(26.4 40.16)"
              textAnchor="middle"
              fontSize="36"
              fontFamily="NewParisKingSize-Regular"
            >
              {text}
            </text>
          </g>
        </g>
      </svg>
    </>
  )
}

export const Bath = ({ number, on }) => {
  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 71 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59.5862 61.2549V61.4485H59.3926"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
        />
        <path
          d="M59.0045 61.4482H8.95209"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
          strokeDasharray="0.39 0.39"
        />
        <path
          d="M8.75847 61.4485H8.56482V61.2549"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
        />
        <path
          d="M8.56482 60.8669V10.8145"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
          strokeDasharray="0.39 0.39"
        />
        <path
          d="M8.56403 10.6214V10.4277H8.75768"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
        />
        <path
          d="M9.14502 10.4277H59.1974"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
          strokeDasharray="0.39 0.39"
        />
        <path
          d="M59.3926 10.4277H59.5862V10.6214"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
        />
        <path
          d="M59.5855 11.0078V61.0602"
          stroke="#0B253C"
          strokeWidth="3.92513"
          strokeMiterlimit="10"
          strokeDasharray="0.39 0.39"
        />
        <path
          d="M25.9604 36.8102C25.9604 35.6259 24.8097 35.0114 23.3349 34.9444V34.9332C24.5303 34.788 25.5694 34.0394 25.5694 32.9557C25.5694 31.7044 24.2846 31.2575 22.6534 31.2575C21.9942 31.2575 21.0334 31.2687 20.5194 31.2687H19.4246V31.3469H20.553V38.9218H19.4246V39H20.5977C21.2345 39 22.3852 39.0112 23.0668 39.0112C24.5415 39.0112 25.9604 38.3297 25.9604 36.8102ZM24.3851 33.1457C24.3851 34.0506 24.0276 34.9221 22.7874 34.9221H21.6702V31.3357H22.6757C23.8935 31.3357 24.3851 31.8385 24.3851 33.1457ZM21.6702 35.0003H22.7763C24.1281 35.0003 24.765 35.6036 24.765 36.8549C24.765 38.3408 24.117 38.933 22.9215 38.933H21.6702V35.0003ZM29.1876 34.8327V31.3469H30.64C31.8243 31.3469 32.1706 31.7491 32.3382 32.4418C32.5058 33.1233 32.517 33.6484 32.8857 33.6484H32.9303V31.2687H26.9419V31.3469H28.0703V38.9218H26.9419V39H33.3772V36.4527H33.3325C32.9639 36.4527 32.908 37.1342 32.7516 37.7822C32.584 38.4749 32.2265 38.9218 31.0534 38.9218H29.1876V34.9109H29.9808C30.5618 34.9109 30.8523 35.112 30.964 35.5477C31.0534 35.9164 31.1763 36.2963 31.4444 36.2963H31.4556V33.4473H31.4444C31.1763 33.4473 31.0534 33.8272 30.964 34.1959C30.8523 34.6316 30.5618 34.8327 29.9808 34.8327H29.1876ZM41.8204 35.2014C41.8204 32.6429 39.8875 31.2575 37.4855 31.2575C37.0721 31.2575 35.9325 31.2687 35.5303 31.2687H34.5248V31.3469H35.6532V38.9218H34.5248V39H35.5191C36.0442 39 37.0944 39.0112 37.6642 39.0112C39.8764 39.0112 41.8204 37.7599 41.8204 35.2014ZM40.5467 35.2126C40.5467 37.8157 39.4741 38.933 37.5748 38.933H36.7704V31.3357H37.5078C39.3848 31.3357 40.5467 32.6094 40.5467 35.2126ZM47.9774 33.7601V31.3022H47.9551C47.6311 31.3022 47.7093 31.8385 47.3964 31.8385C47.0501 31.8385 46.6702 31.1793 45.5977 31.1793C44.3575 31.1793 43.4973 31.9837 43.4973 33.0563C43.4973 34.1177 44.1006 34.9668 45.4189 35.4472L46.1228 35.7041C47.2959 36.1287 48.1673 36.5421 48.1673 37.4917C48.1673 38.5419 47.106 39 46.0893 39C44.9385 39 44.1788 38.5308 44.0112 37.637C43.8436 36.7208 43.6313 36.408 43.3744 36.408H43.3297V39.0112H43.3744C43.7095 39.0112 43.5531 38.3967 43.9106 38.3967C44.257 38.3967 44.7039 39.0782 46.0893 39.0782C47.5752 39.0782 48.5025 38.2068 48.5025 36.8884C48.5025 35.5477 47.6981 34.8997 46.3797 34.4193L45.7317 34.1847C44.7262 33.816 43.7989 33.3691 43.7989 32.5535C43.7989 31.7491 44.7151 31.2575 45.5865 31.2575C46.6926 31.2575 47.2512 31.9949 47.3629 32.7211C47.4523 33.2797 47.6199 33.7601 47.9215 33.7601H47.9774Z"
          fill="#0B253C"
        />
      </svg>
    </>
  )
}
export const Bed = ({ number, on }) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 54.95 54.95">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <rect x="2.11" y="3.51" width="50.08" height="47.9" fill="none" />
            <path
              d="M53,52.79V53h-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M52.4,53h-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2.16,53H2v-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2,52.4v-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2,2.16V2h.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2.54,2H52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M52.79,2H53v.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M53,2.54V52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <text
              fill="#003141"
              transform="translate(26.4 30.16)"
              textAnchor="middle"
              alignmentBaseline="middle"
              fontSize="13"
              fontFamily="NewParisKingSize-Regular"
            >
              BEDS
            </text>
          </g>
        </g>
      </svg>
    </>
  )
}
export const Compass = ({ number, on }) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 54.95 54.95">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <rect x="2.11" y="3.51" width="50.08" height="47.9" fill="none" />
            <path
              d="M53,52.79V53h-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M52.4,53h-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2.16,53H2v-.19"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2,52.4v-50"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M2,2.16V2h.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M2.54,2H52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <path
              d="M52.79,2H53v.2"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
            />
            <path
              d="M53,2.54V52.6"
              fill="none"
              stroke="#0b253c"
              strokeMiterlimit="10"
              strokeWidth="3.93"
              strokeDasharray="0.39 0.39"
            />
            <text
              fill="#003141"
              transform="translate(26.4 30.16)"
              textAnchor="middle"
              alignmentBaseline="middle"
              fontSize="12"
              fontFamily="NewParisKingSize-Regular"
            >
              FACING
            </text>
          </g>
        </g>
      </svg>
    </>
  )
}
